import { HttpClient } from "@angular/common/http";
import { inject } from "@angular/core";
import { NptConfigurationService } from "@npt/sdk";


export class CommonService {
    protected _httpClient = inject(HttpClient);
    protected _configurationService: NptConfigurationService = inject(NptConfigurationService);
    protected _apiUrl = this._configurationService.config.beURL;
}